import gql from 'graphql-tag';

export default gql`
  query siteLayoutTranslations {
    allegiantApplication(name: MYALLEGIANTREBRANDING) {
      ... on MyAllegiantRebranding {
        translations(language: enUS) {
          ... on MyAllegiantRebrandingTranslations {
            usermenu {
              headerGreeting
              headerPointsBalanceText
            }
          }
        }
      }
    }
  }
`;
